import moment from 'moment';

export const DEFAULT_COUNT_DATE = moment();
export const DEFAULT_STAFF_COUNT = 3;
export const DEFAULT_WORK_ORDER = '';
export const DEFAULT_PRODUCT_CODE = '';
export const DEFAULT_LINE_STATUS_ID = 1;
export const DEFAULT_LINE_STATUS_DATE = moment();
